<template>
  <div>
    <h3 class="mt-8">塾情報</h3>
    <font size=2>※ 必須項目</font>
    <v-row>
      <v-col class="pt-0" cols="12">
        <tbody>
          <!-- お客様No -->
          <tr>
            <th class="table-label">
              1. お客様No.
              <font color="#ff4a3d" size="2">❇︎</font>
              <font class="float-right question" style="cursor:pointer" @click="showPDF">？</font>
              <br>
              <font size="1">※半角数字９文字</font>
            </th>
            <td>
              <v-text-field
                class="text-field"
                :value="customer.clientCode"
                @change="setCustomerPayload({ clientCode: $event})"
                outlined
                dense
                required
                :rules="clientCodeRules"
                color="secondary"
                :disabled="disabled"
              ></v-text-field>
            </td>
          </tr>

          <!-- 塾名 -->
          <tr>
            <th>2. 貴塾名
              <font color="#ff4a3d" size="2">❇︎</font>
              <v-tooltip top content-class="tooltip__text">
                <template #[`activator`]="{ on, attrs }">
                  <font class="float-right question" v-bind="attrs" v-on="on">？</font>
                </template>
                <span>弊社との契約でご登録いただいている塾名を入力</span>
              </v-tooltip>
              <br>
              <font size="1">※50文字まで</font>
            </th>
            <td>
              <v-text-field
                class="text-field"
                :value="customer.name"
                @change="setCustomerPayload({ name: $event})"
                outlined
                dense
                required
                :rules="rules.customerName"
                color="secondary"
                :disabled="disabled"
              ></v-text-field>
            </td>
          </tr>

          <!-- 住所 -->
          <tr>
            <th>
              3. 住所 <font color="#ff4a3d">❇︎</font>
              <br>
              <font size="1">※100文字まで</font>
              <br>
              <font size="1">※郵便番号ハイフンなし</font>
            </th>
            <td>
              <!-- 郵便番号 -->
              <div class="address__area">
                <p class="address__mark mt-2 mb-1 ml-2 mr-1">〒</p>
                <input
                  :value="customer.postalCode"
                  @change="setCustomerPayload({ postalCode: $event.target.value})"
                  class="input__postal-code"
                  :disabled="disabled"
                />
                <v-btn
                  class="ml-2"
                  color="secondary"
                  x-small
                  :disabled="!customer.postalCode || isConfirm"
                  @click="postalSearch">
                  検索
                </v-btn>
              </div>
              <!-- 住所 -->
              <v-text-field
                class="text-field__address mt-4"
                :value="customer.address"
                @change="setCustomerPayload({ address: $event})"
                outlined
                dense
                required
                :rules="rules.address"
                color="secondary"
                :disabled="disabled"
              ></v-text-field>
            </td>
          </tr>

          <!-- 電話番号 -->
          <tr>
            <th>
              4. 代表電話番号 <font color="#ff4a3d" size="2">❇︎</font>
              <br>
              <font size="1">※半角数字11文字まで(ハイフンなし)</font>
            </th>
            <td>
              <v-text-field
                class="text-field"
                :value="customer.tel"
                @change="setCustomerPayload({ tel: $event})"
                type="tel"
                outlined
                dense
                required
                :rules="rules.tel"
                color="secondary"
                :disabled="disabled"
              ></v-text-field>
            </td>
          </tr>

          <!-- メールアドレス -->
          <tr>
            <th>5. メールアドレス
              <font color="#ff4a3d" size="2">❇︎</font>
              <v-tooltip top content-class="tooltip__text">
                <template #[`activator`]="{ on, attrs }">
                  <font class="float-right question" v-bind="attrs" v-on="on">？</font>
                </template>
                <span>スマートフォン、タブレットのみのアドレスは不可</span>
              </v-tooltip>
              <br>
              <font size="1">※100文字まで</font>
              <br>
              <font size="1">※許可記号「_」「.」「+」「-」「?」「/」</font>
              <br>
              <font size="1">※「@(アットマーク)」の前は64文字まで</font>
            </th>
            <td>
              <v-text-field
                class="text-field"
                :value="customer.mail"
                @change="setCustomerPayload({ mail: $event})"
                outlined
                dense
                required
                :rules="rules.mail"
                color="secondary"
                :disabled="disabled"
              ></v-text-field>
            </td>
          </tr>

          <!-- EN担当者名 -->
          <tr>
            <th>
              6. 弊社担当者または弊社特約店
              <br>
              <font size="1">※20文字まで</font>
            </th>
            <td>
              <v-text-field
                class="text-field"
                :value="customer.enChargePerson"
                @change="setCustomerPayload({ enChargePerson: $event})"
                outlined
                dense
                :rules="rules.representative"
                color="secondary"
                :disabled="disabled"
              ></v-text-field>
            </td>
          </tr>

          <!-- ロゴ -->
          <tr>
            <th>
              7. ロゴ
              <br>
              <font size="1">※拡張子は .gif .jpg .jpeg .png</font>
              <br>
              <font size="1">※画像サイズは1MBまで</font>
              <br>
              <font size="1">※横幅：縦幅 = 110:50の比率にリサイズされます</font>
            </th>
            <td>
              <v-file-input
                accept="image/gif, image/jpg, image/jpeg, image/png"
                class="text-field__file"
                label="ロゴファイル"
                :show-size="!!customer.logoImage"
                :clearable="false"
                color="secondary"
                truncate-length="50"
                :value="customer.logoFile"
                @change="onChange"
                @click:append-outer.stop="onClear"
                :append-outer-icon="customer.logoImage && !disabled ? 'mdi-delete' : ''"
                :rules="rules.logo"
                :disabled="disabled"
              ></v-file-input>
              <v-img
                v-if="customer.logoImage"
                :src="customer.logoImage"
                class="ml-8 my-4"
                contain
                max-height="165px"
                max-width="165px"
                position="top"/>
            </td>
          </tr>

          <!-- 請求方法 -->
          <tr>
            <th>8. 請求方法 <font color="#ff4a3d" size="2">❇︎</font></th>
            <td>
              <v-radio-group
                :value="customer.invoiceType"
                @change="setCustomerPayload({ invoiceType: $event})"
                class="radio-group ml-3 mb-3"
                :rules="[v => !!v || '請求方法を選択してください']"
                row
                :disabled="disabled"
              >
                <v-radio
                  class="mb-2"
                  label="年間"
                  value="yearly_billing"
                  color="secondary"
                ></v-radio>
                <v-radio
                  class="mb-2"
                  label="月々"
                  value="monthly_billing"
                  color="secondary"
                ></v-radio>
              </v-radio-group>
            </td>
          </tr>

          <!-- 利用開始時期 ※新規場合のみ表示する -->
          <tr v-if="isNewCustomer">
            <th>9. 利用開始時期 <font color="#ff4a3d" size="2">❇︎</font></th>
            <td>
              <v-radio-group
                :value="customer.startTime"
                @change="setCustomerPayload({ startTime: $event})"
                class="radio-group ml-3 mb-3"
                :rules="[v => !!v || '利用開始時期を選択してください']"
                :disabled="disabled"
              >
                <table >
                  <tr>
                    <th class="start-time__th">
                      <v-radio
                        label="申込承認後すぐ利用する。"
                        value="start_now"
                        color="secondary"
                      ></v-radio>
                    </th>
                    <td class="start-time__td">
                      弊社登録完了後、すぐに利用を開始する<br>
                      （利用開始のご連絡は、申し込み後5営業日以内にいたします。）
                    </td>
                  </tr>
                  <tr>
                    <th class="start-time__th">
                      <v-radio
                        label="翌月の月初めから利用する。"
                        value="start_next_month"
                        color="secondary"
                      ></v-radio>
                    </th>
                    <td class="start-time__td">
                      翌月初めの営業日より利用を開始する<br>
                      （弊社営業日のため、月初すぐとは限りません）
                    </td>
                  </tr>
                </table>
              </v-radio-group>
            </td>
          </tr>
        </tbody>
      </v-col>
    </v-row>

    <!-- ロゴ削除時の確認ダイアログ -->
    <v-confirm-dialog
      ref="confirm"
      :title="confirmDialogTitle"
      :message="deleteMessage"
      buttonMessage="削除"
      @confirm="confirmDeletion"
    />
  </div>
</template>

<script>
import rules from '../../rules'
import { mapState, mapMutations, mapGetters } from 'vuex'
import axiosJsonpAdapter from 'axios-jsonp'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'

export default {
  components: {
    VConfirmDialog,
  },

  props: {
    isConfirm: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    confirmDialogTitle: '',
    rules: rules
  }),

  mounted() {
    // 新規申込でロゴ画像がセットされていたら表示するための処理を行う
    if (this.isNewCustomer && this.customer.logoFilename) {
      this.setCustomerPayload({
        logoFile: this.dataURLtoFile(this.customer.logoImage, this.customer.logoFilename)
      })
    }
  },

  watch: {},

  computed: {
    ...mapState('enrollment', [
      'customer',
    ]),
    ...mapGetters('enrollment', [
      'isNewCustomer',
    ]),
    deleteMessage() {
      return `${this.customer.logoFilename} を削除します。よろしいですか。`
    },
    disabled() {
      return this.isConfirm || !this.isNewCustomer
    },
    clientCodeRules() {
      const newRules = this.rules.clientCode
      newRules.unshift(
        v => (!['602221360', '605561341', '605561438'].includes(v)) || '弊社営業所または弊社特約店から教材購入時に使用している番号をご入力ください',
      )
      newRules.unshift(
        v => (!v.match(/^7/)) || '弊社営業所または弊社特約店から教材購入時に使用している番号をご入力ください',
      )
      return newRules
    }
  },

  methods: {
    ...mapMutations('enrollment', [
      'setCustomerPayload',
    ]),
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {type:mime});
    },
    onChange(e) {
      this.setCustomerPayload({ logoFile: e })
      const reader = new FileReader()
      reader.readAsDataURL(this.customer.logoFile)
      reader.onload = (e) => {
        this.setCustomerPayload({ logoFilename: this.customer.logoFile.name })
        this.setCustomerPayload({ logoImage: e.target.result })
      }
    },
    onClear() {
      this.confirmDialogTitle ='ロゴ削除'
      this.$refs.confirm.open()
    },
    async confirmDeletion() {
      this.setCustomerPayload({ logoImage: null })
      this.setCustomerPayload({ logoFilename: '' })
      this.setCustomerPayload({ logoFile: new File([], '', {}) })
    },
    async postalSearch() {
      const res = await this.$axios.get(process.env.VUE_APP_ZIPCODE_API_URL, {
        adapter: axiosJsonpAdapter,
        params: {
          zipcode: this.customer.postalCode
        }
      })

      if (!res) {
        this.$toasted.global.error({ message: '郵便番号が正しくありません。' })
      } else if (!res.data.results){
        this.$toasted.global.error({ message: res.data.message || '郵便番号が正しくありません。' })
      } else {
        const data = res.data
        const result = data.results[0]
        const address =  result.address1 + result.address2 + result.address3
        this.setCustomerPayload({ address: address})
      }
    },
    showPDF() {
      window.open('https://www.en-plat.jp/%E3%81%8A%E5%AE%A2%E6%A7%98CD%E7%A2%BA%E8%AA%8D%E7%94%A8.pdf')
    }
  }
}
</script>

<style lang="stylus" scoped>

th
  width 30%
  height 30px
  background-color #3b7cab
  text-align left
  color #fff
  font-size 14px
  vertical-align top
  padding 9px
  border-bottom 1px solid #ddd

td
  width 1500px
  background-color #fff1f8
  border 1px solid white

.start-time
  &__th
    background-color: #fff1f8;
    max-width 200px
    border none
  &__td
    font-size 13px
    border none
    text-align left

.text-field
  margin 10px
  min-height 10px
  background-color white
  &__file
    width 400px
    margin 10px
    min-height 10px
  &__address
    width 400px
    margin 10px
    min-height 10px
    background-color white

.attention
  font-size 12px
  margin-bottom 5px

.hint
  font-size 11px
  color #252525
  margin-bottom 5px

.address
  &__area
    height 25px
  &__mark
    display inline-block
    font-size 14px

.input__postal-code
  display inline-block
  border 1px solid #a8a8a8
  border-radius 4px
  background-color white
  width 100px
  padding 0px 4px

.input__postal-code:disabled
  color #aeaeae

.tooltip__text
  font-weight bold

.question
  font-size 16px
  text-shadow 0px 1px white
  color #ff4a3d !important

.radio-group
  background-color #fff1f8 !important

</style>
